var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer__container"},[_c('div',{staticClass:"selected-items"},[_vm._v(" "+_vm._s(_vm.entity)+" Selected: "),_c('ez-badge',{attrs:{"type":"blue","count":_vm.itemsCount}})],1),_c('ez-button',{on:{"click":_vm.onCtaClick}},[_vm._v(" Update "+_vm._s(_vm.entity)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }